import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeNote = gql`
    type Note {
      id: ID
      rev: String
      customerNumber: String
      noteNumber: String
      lineNumber: String
      text: String
      displayDuringReceiptCreation: Boolean
      modifiedAt: String
    }

    type Notes {
      total: Int
      items: [Note]
      cartConfirmRequired: Boolean
    }

    input UpdateNoteMutationValues {
      text: String
      lineNumber: String = "1"
      displayDuringReceiptCreation: Boolean
    }

    input CreateNoteMutationValues {
      customerNumber: String!
      lineNumber: String = "1"
      text: String
      displayDuringReceiptCreation: Boolean
    }

    type Query {
      notes(
        offset: Int = ${DEFAULTS.QUERY.OFFSET}
        limit: Int = ${DEFAULTS.QUERY.LIMIT}
        sort: Sort 
        sortWithinLimits: Boolean = false
        lang: String = ""
        cdn: Boolean = true
        noteNumber: String
        customerNumber: String!
        displayDuringReceiptCreation: Boolean
      ): Notes

      note(
        lang: String = ""
        cdn: Boolean = true
        id: ID!
      ): Note

    }

    type Mutation {
      updateNote(
        lang: String = ""
        cdn: Boolean = true
        id: ID!
        values: UpdateNoteMutationValues
      ): Note

      createNote(
        lang: String = ""
        cdn: Boolean = true
        values: CreateNoteMutationValues
      ): Note

      deleteNote(
        lang: String = ""
        cdn: Boolean = true
        id: ID!
      ): Boolean
    }
`

export { typeNote }

export default typeNote
